import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'
import React from 'react'

import type {TariffsCountry, ZonesInfo} from '../../api'
import {Header} from '../../components/Header/Header@desktop'
import {Paper} from '../../components/ui'
import type {PathWithCountry} from '../../types'
import styleClasses from './classes@desktop.module.css'
import {CitiesListContainer} from './components/CitiesList/index@desktop'
import {Map} from './components/Map/Map'
import { useConfig } from '../../config'

type Props = {
  zones: ZonesInfo
  path: PathWithCountry
  countries: TariffsCountry[]
}

export function LocationPage({zones, path, ...headerProps}: Props) {
  const i18n = useI18n()
  const {brand} = useConfig()

  return (
    <div className={styleClasses.page}>
      <Header
        {...headerProps}
        path={path}
        subtitle={
          <Typography density="tight" level="body2" weight="regular">
            {i18n(
              'tariffs-v3.header.subtitle',
              'Выберите город, чтобы посмотреть все доступные тарифы и скачать их одним файлом',
            )}
          </Typography>
        }
      />

      <div className={styleClasses.mainContent}>
        <CitiesListContainer country={path.country} zones={zones} />

        <Paper className={styleClasses.mainMap}>
          <Map brand={brand} country={path.country} zones={zones.allZones} />
        </Paper>
      </div>
    </div>
  )
}
